/**
 * profileService.js — User profile + global XP leaderboard.
 */
import { apiClient } from "./api";

export const profileService = {
  getProfile: (userId) => apiClient.get(`/profile/${userId}`).then((r) => r.data),
  // Public-safe subset used by the clickable-username popover on
  // leaderboard / room player list / scoreboard.
  getPublicProfile: (userId) =>
    apiClient.get(`/profile/${userId}/public`).then((r) => r.data),
  getBadgeCatalog: () => apiClient.get("/badges/catalog").then((r) => r.data),
};

export const leaderboardService = {
  // Returns { items: [...], limit, offset, has_more }.
  getGlobal: ({ limit = 20, offset = 0 } = {}) => {
    const qs = new URLSearchParams();
    qs.set("limit", String(limit));
    qs.set("offset", String(offset));
    return apiClient.get(`/leaderboard?${qs.toString()}`).then((r) => r.data);
  },
};
